export default __webpack_public_path__ + "d748c3cd3d47727c16e28f68c473be4f.svg";